import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { JobcardService } from 'src/app/services/jobcard.service';
import { PartnerService } from 'src/app/services/partner.service';

@Component({
  selector: 'app-workshop-jobcard-transfer',
  templateUrl: './workshop-jobcard-transfer.component.html',
  styleUrls: ['./workshop-jobcard-transfer.component.scss']
})
export class WorkshopJobcardTransferComponent {

  @Input() jobcard: any;
  @Input() otherShops;
  @Output() jobcardChange = new EventEmitter<any>();


  public NewPartnerID: any = 0;
  public NewTechnicianID: any;
  public selectedServiceTypes: any = [];
  public shopList: any = [];
  public technicianList: any = [];
  public serviceTypes: any = [];
  public originalServiceTypesList: any = [];
  public movingJobcard: boolean = false;


  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    public jobcardService: JobcardService,
    public partnerService: PartnerService,
  ) { }

  ngOnInit() {
    console.log('Workshop Jobcard Transfer Component Initialized', this.jobcard);
    this.shopList = [{ label: this.translate.instant('bikeshop.modal.update_job_card.job_card.select_a_shop'), value: 0 }, ...this.otherShops.map(x => { return { label: x.name, value: x.id } })];

    this.originalServiceTypesList = this.jobcard.selectedServiceTypes.map(x => {
      return { label: x.serviceType, value: x.serviceTypeID };
    });

  }


  shopSelected() {
    this.technicianList = [];
    this.serviceTypes = [];
    this.selectedServiceTypes = [];
    this.NewTechnicianID = null;

    if (this.NewPartnerID > 0) {
      this.jobcardService.getOtherShopTechnicianList(this.NewPartnerID).subscribe(result => {
        if (result && result.length > 0) {
          this.technicianList = result.map(x => { return { label: x.firstname + ' ' + x.surname, value: x.id } });
          this.NewTechnicianID = this.technicianList[0].value;
        } else {
          this.technicianList = [];
        }
      }, err => {
        this.technicianList = [];
      });

      this.partnerService.getPartnerServiceTypesDropDowns(this.NewPartnerID).subscribe(serviceTypes => {
        var GroupName = "";
        var serviceTypes_temp = [];
        serviceTypes
          .filter((serviceType) => {
            return serviceType.IsActive;
          })
          .map((serviceType) => {
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant("general.not_grouped");
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              serviceTypes_temp.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
              });
            }
            serviceTypes_temp.push({
              label: serviceType.ServiceTypeDescription,
              value: serviceType.ID,
              hours: serviceType.Hours,
              cost: serviceType.Cost,
            });
          });
        serviceTypes_temp.forEach(serviceType => {
          if (this.originalServiceTypesList.map(x => { return x.label }).indexOf(serviceType.label) > -1) {
            this.selectedServiceTypes.push(serviceType.value);
          }
        });
        this.selectedServiceTypes = JSON.parse(JSON.stringify(this.selectedServiceTypes));
        this.serviceTypes = serviceTypes_temp;
      }, err => {
        this.selectedServiceTypes = [];
      })
    }

  };

  validateForm() {
    return this.NewPartnerID > 0 && this.NewTechnicianID > 0 && this.selectedServiceTypes.length > 0;
  }

  cancel() {
    this.activeModal.dismiss();
  }

  moveJobCard() {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      NewPartnerID: this.NewPartnerID,
      NewTechnicianID: this.NewTechnicianID,
      ServiceID: this.jobcard.id,
      NewServiceTypes: this.selectedServiceTypes
    }
    this.movingJobcard = true;
    this.jobcardService.moveJobCard(data).subscribe(result => {
      this.movingJobcard = false;
      this.jobcardChange.emit({ ...this.jobcard, partnerID : this.NewPartnerID, technicianID: this.NewTechnicianID });
      this.activeModal.close({moved : true, shopName: this.shopList.find(x => x.value === this.NewPartnerID)?.label || ''});
    }, err => {
      this.movingJobcard = false;
    })
  }

}
